// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6f87e7d8","239":"6c68be09","453":"73f6eb79","732":"1035b0e2"}[chunkId] + ".chunk.js";
};